import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import pl from "./locales/pl.json";

function getInitialLocale() {
  // Polish is the default; English is opt-in via the language switcher
  // (which persists the choice to localStorage). Browser language is not
  // consulted because Polish users often run English-language browsers
  // but still expect the app in Polish.
  const stored = localStorage.getItem("locale");
  if (stored && ["en", "pl"].includes(stored)) {
    return stored;
  }
  return "pl";
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: "en",
  messages: { en, pl },
});

export function setLocale(locale) {
  if (["en", "pl"].includes(locale)) {
    i18n.global.locale.value = locale;
    localStorage.setItem("locale", locale);
    document.documentElement.lang = locale;
  }
}
